import { AppState, SubNavigation } from '../types/store';
import { FacetPageType } from '../../types/api';
import { Pages } from '../../constants';
import { PapiUser } from '@wix/da-types-papi';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { getDataEntityById } from '@wix/da-shared-react/pkg/redux/entities/selectors';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';
import { getSelectedNetworkBarItem } from './app';
import {
  getIsLoggedIn,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession';

export function getPage(state: AppState) {
  return state.page;
}

/** Determine the next page_type for the purposes of xhr loading
 *  when using the Header navigation links */
export function getPageForNextPageType(
  state: AppState,
  nextPageType: FacetPageType
) {
  const currentPage = getPage(state);

  switch (nextPageType) {
    case 'dailydeviations':
      return Pages.DailyDeviation;
    case 'topics':
      return Pages.Topics;
    case 'tag':
      return Pages.Tag;
    default:
      // if we're searching, continue searching and consider the Header links
      // to be search categories. Otherwise, if it's not one of the three
      // unique categories above assume it's faceted
      return currentPage === 'search' ? Pages.Search : Pages.Faceted;
  }
}

export function getCurrentPageType(state: AppState) {
  return state.currentPageData?.pageType;
}

export function getCurrentFeedType(state: AppState) {
  return (
    state.facet.effectivePageType ??
    getFeedTypeSubnavigation(state)?.currentValue ??
    state.currentPageData?.feedType
  );
}

export function getFeedTypeSubnavigation(
  state: AppState
): SubNavigation | undefined {
  return getSubnavigationByType(state, 'content_type');
}

export function getCurrentOrder(state: AppState) {
  return (
    state.facet.effectiveOrder ??
    getOrderSubnavigation(state)?.currentValue ??
    undefined
  );
}

export function getOrderSubnavigation(
  state: AppState
): SubNavigation | undefined {
  return getSubnavigationByType(state, 'order');
}

function getSubnavigationByType(
  state: AppState,
  type: string
): SubNavigation | undefined {
  return state.subnavs.find(subnav => subnav.type === type);
}

export function getThisGroup(state: AppState) {
  const groupId = state.currentPageData?.thisGroup;
  if (!groupId) {
    return;
  }

  return getDataEntityById<PapiUser, AppState>(state, userSchema, groupId);
}
export function getThisTopic(state: AppState) {
  return state.currentPageData?.thisNeco;
}
export function getTopTopics(state: AppState) {
  return state.currentPageData?.topTopics;
}

export function getRelatedTopics(state: AppState) {
  return state.currentPageData?.relatedTopics;
}

export function getActiveSiteHeaderItem(state: AppState) {
  if (flagEnabled(state, 'networkbar')) {
    return getSelectedNetworkBarItem(state);
  }

  return getPage(state) === Pages.Search ? 'search' : 'browse';
}

export function getCanSubmitToPostFeed(
  state: AppState,
  type: 'journal' | 'status' | 'poll'
) {
  // no postbox for logged out
  if (!getIsLoggedIn(state)) {
    return false;
  }

  // no journals on mobile
  if (type === 'journal' && getIsMobile(state)) {
    return false;
  }

  const pageType = getCurrentPageType(state);

  if (pageType === 'groups') {
    // groups only support journals
    if (type !== 'journal') {
      return false;
    }

    // check privs
    return !!getThisGroup(state)?.extendedGroup?.apps?.posts?.canSubmit;
  }

  return true;
}
